import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

import { licencedPharmaciesBanner } from "@/assets/images";
import { licencedPharmaciesBannerV2 } from "@/assets/images";
import { useIsABTest } from "@/hooks/useIsABTest";

const OnlyLicencedPharmaciesBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { isABTest_6_Header } = useIsABTest();

  return (
    <>
      {
        !isABTest_6_Header &&
          <p className="section-title !mb-6">
            We only work with licensed compounding pharmacies. All our medication go
            through an extreme vetting process before arriving at your door.
          </p>
      }
      <img
        src={isABTest_6_Header ? licencedPharmaciesBannerV2 : licencedPharmaciesBanner}
        className="mx-auto"
        alt="Only licenced pharmacies"
      />
      <Button
        type={isABTest_6_Header ? ButtonType.NEXT : ButtonType.CONTINUE}
        onClick={() => setQuestionAnswer(true)}
      />
    </>
  );
};

export { OnlyLicencedPharmaciesBanner };
